import { createContext } from 'react'

/**
 * **Ist mehr als eine Zeile der Liste gewählt?** (#303) — als Frage, nicht als Wert.
 *
 * Als Prop an jeder Zeile kippte der Wechsel von einer auf zwei gewählte Zeilen ALLE Zeilen der Liste in
 * ein neues Rendern. Die Funktion bleibt dieselbe; gefragt wird erst, wenn es zählt — beim Öffnen von
 * Menü und Verschiebe-Kasten. Den Play-Button blendet die Klasse `task-list--multi-selected` aus.
 */
export const MultiSelectionContext = createContext<(() => boolean) | null>(null)
